import bodymovin from "lottie-web";

export default class Search {
    constructor() {
        this.addEvents();
    }

    addEvents() {
        let searchInput = '';
        let checkFilterLength = 0;
        let firstClick = true;
        let pageGlobal = 1;
        let prevCat = '';
        let pageNumb = '';
        let globalMassechet = '';
        let currentLang = $('section.search').attr('data-lang') != 'en' ? '/he' : '';
        let searchPage = false;

        let filterAjax = {
            page: 1,
            cat: '',
            authors: '',
            masechet: '',
            input: '',
            sort: 'date',
            lang: $('html').attr('lang') == 'he-IL' ? 'he' : 'en'
        }

        if($('section').hasClass('search')){
            searchPage = true;
        }

        if($('div').hasClass('header-main__search-popup')){
            $('.header-main__search-popup form, .header-main__mobile--search form').attr('action', currentLang+'/search');
            $('.header-main__search-popup form input[type="search"], .header-main__mobile--search form input[type="search"]').attr('name', 'input');
        }

        $('.search__filter--title').on('click', function(event) {
            event.preventDefault();
            const $parent = $(this).closest('.search__filter');
            $parent.toggleClass('active');
        });

        $('.search__filter--cat').on('click', function (e) {
            $(this).toggleClass('active');
            $('.search__filter--cat').not(this).removeClass('active');
            generateLink();
        });

        $('.search__filter--cat.has-sub > svg').on('click', function (e) {
            $(this).closest('.search__filter--cat.has-sub').toggleClass('open');
        });

        $('.search__select > span').on('click', function (e){
            e.preventDefault();
            let list = $(this).parents('.search__select')
            if(list.hasClass('open')){
                list.removeClass('open');
            }else{
                list.addClass('open');
            }
        });


        $('.search__select > span input').on('input', function (e){
            e.preventDefault();
            let val = $(this).val().toLowerCase();
            let list = $(this).parents('.search__select')
            list.addClass('open');
            let choose = list.find('.search__select--list div');
            choose.removeClass('hide');
            choose.each(function (i,e){
                let dataVal =  $(this).attr('data-value').toLowerCase();
                if(dataVal.indexOf(val) === -1){
                    $(this).addClass('hide');
                }
            })
        });

        $('.search__input input').keypress(function (e) {
            if(e.which == 13){
                let val = $('.search__input input').val();
                pageGlobal = 1;
                $('.search__result--text i').html(val);
                if(val.length >=3){
                    $('.search__result--text').css('display', 'flex');
                }else{
                    $('.search__result--text').css('display', 'none');
                }
                searchInput = val;
                generateLink();
            }
        });

        $('.search__select--remove').on('click', function (e){
            let parent = $(this).parents('.search__select');
            setTimeout(()=>{
                parent.removeClass('open').removeClass('choised');
                parent.find('.search__select--list > div.active').click();
            }, 1)
        })

        $('.search__select--list').on('click', 'div', function (e){
            let list = $(this).parents('.search__select');
            list.addClass('choised')
            let defaultText = $(this).parents('.search__select').find('span').attr('data-default');
            if(!$(this).hasClass('multiple')){
                if($(this).hasClass('active')){
                    $(this).removeClass('active');
                    if(list.find('.search__select--list div.active').length == 0){
                        list.removeClass('choised');
                        $(this).parents('.search__select').find('span i').html(defaultText);
                    }
                }else{
                    $(this).parents('.search__select--list').find('div').removeClass('active');
                    $(this).parents('.search__select').find('span i').html($(this).text());
                    $(this).addClass('active');
                }
                list.removeClass('open');
            }else{
                if($(this).hasClass('active')){
                    $(this).removeClass('active');
                }else{
                    $(this).addClass('active');
                }
                list.removeClass('open');
                $(this).parents('.search__select').find('span input').val('');
                searchPage ? generateMultiple( $(this).parents('.search__select')) : '';
            }
            searchPage ? generateLink() : '';
        });

        function generateMultiple(el){
           let allVal = el.find('.search__select--list div.active');
           if(allVal.length > 0){
               el.find('.multiple-select div').remove();
               allVal.each(function (i,e){
                   let curr = $(this).text();
                   let val = $(this).attr('data-value');
                   $('<div>'+curr+'<span data-val="'+val+'"></span><div>').appendTo(el.find('.multiple-select'));
               })
               el.find('.multiple-select').css('display', 'flex');
           }else{
               el.find('.multiple-select div').remove();
           }

        }

        $('.multiple-select').on('click', 'span', function (e){
            let val = $(this).attr('data-val');
            $(this).parents('.search__select').find('.search__select--list div.active[data-value="'+val+'"]').removeClass('active');
            generateMultiple($(this).parents('.search__select'));
            generateLink();
        });

        $('.search__start--item:not(.permalink)').on('click', function (e){
            let current = $(this).find('.search__start--name').text().toLowerCase();
            $('.search__filter--cat[data-full="'+current+'"]').click();
            $('.search__start').css('display', 'none');
        });


        $('.post-paginate__sort--item.searchSort').on('click', function (e){
            e.preventDefault();
            let value = $(this).text().trim();
            let sortBy = $(this).data('sortby').trim();
            let list = $(this).parents('.post-paginate__sort');
            list.hasClass('open') ? list.removeClass('open') : list.addClass('open');
            list.find('span em').html(value);
            $(this).parents('.post-paginate__sort--list').find('div').removeClass('active');
            $(this).addClass('active');
            let slug_sort = sortBy.toLowerCase().replace(/\s+/g, '-');
            window.history.pushState('', '', currentLang+'/search/?sort='+slug_sort);
            generateLink();
        })

        function generateLink(bool){
            $('.search__result--all').html(' ');
            $('.search__pagination--right').html(' ');
            const params = new URL(window.location.href).searchParams;
            let filter = [];
            let inputEnter = false;
            let emptyFilter = true;
            let dafCat = false;
            filterAjax.cat = '';
            filterAjax.page = 1;
            filterAjax.input = '';
            filterAjax.masechet = '';
            filterAjax.authors = '';
            filterAjax.sort = 'date';
            filterAjax.lang = $('html').attr('lang') == 'he-IL' ? 'he' : 'en';

            if(searchInput){
                filter.push('input='+ searchInput);
                $('.search__result--text span').html($('.search__right').attr('data-search'));
                inputEnter = true;
                emptyFilter = false;
                filterAjax.input = searchInput;
            }else{
                $('.search__result--text span').html($('.post-paginate__sort--item.searchSort.active').text());
            }

            if($('.filterCat .search__filter--cat.active').length > 0){
                let cat = [];
                let catName = [];
                let subCat = false;
                let dafyomi = false;
                $('.filterCat .search__filter--cat.active').each(function (i,e){
                    cat.push($(this).attr('data-cat'));
                    catName.push($(this).text());
                    if($(this).parents('div').hasClass('search__filter--sub')){
                        subCat = true;
                    }
                    if($(this).attr('data-full') == 'daf yomi'){
                        dafyomi = true;
                    }
                })

                filter.push('cat='+cat.join(','));
                if(!inputEnter){
                    $('.search__result--text i').html( catName.join(','));
                    if(subCat) {
                        let allWpml = AssetsPath.translations.All
                        $('.search__result--text span').html(`${allWpml}:`);
                        $('.search__result--beyong').css('display', 'block');
                        $('.search__result--follow').css('display', 'flex');
                        
                        // Update the description based on the selected category
                        if (cat.length > 0 && typeof categoryDescriptions !== 'undefined') {
                            const selectedCat = cat[0]; // Use the first selected category
                            if (categoryDescriptions[selectedCat]) {
                                $('.search__result--beyong').html(categoryDescriptions[selectedCat]);
                            } else {
                                // Clear the content if no description exists for this category
                                $('.search__result--beyong').html('');
                            }
                        } else {
                            // Clear the content if no category is selected
                            $('.search__result--beyong').html('');
                        }
                    }else{
                        $('.search__result--beyong').css('display', 'none');
                        $('.search__result--follow').css('display', 'none');
                    }
                }

                if(dafyomi){
                    $('.search__result--dafyomi').css('display', 'flex');
                }else{
                    $('.search__result--dafyomi').css('display', 'none');
                }
                emptyFilter = false;
                filterAjax.cat = cat.join(',');

                if(prevCat != filterAjax.cat){
                    filterAjax.page = 1;
                    pageGlobal = 1;
                }

                prevCat = filterAjax.cat;
                if(prevCat == 'daf' || prevCat == 'all'){
                    dafCat = true;
                    $('.search__result--one').removeClass('hide');
                }else{
                    $('.search__result--one').addClass('hide');
                }
            }

            if($('.filterMasechet .search__filter--list .search__select--list div.active').length > 0){
                let masachet = [];
                let nameMas = [];
                $('.filterMasechet .search__filter--list .search__select--list div.active').each(function (i,e){
                    masachet.push($(this).attr('data-tax'));
                    nameMas.push($(this).text());
                })
                filter.push('masachet='+masachet.join(','));
                emptyFilter = false;
                filterAjax.masechet = masachet.join(',');
                $('.search__result--one ').removeClass('hide');
                if(globalMassechet != masachet.join(',')) {
                    globalMassechet = masachet.join(',');
                    getPageNumber(masachet.join(','));
                }
            }else{
                $('.search__result--one').addClass('hide');
            }

            if($('.filterUser .search__select--list div.active').length > 0){
                let users = [];
                $('.filterUser .search__select--list div.active').each(function (i,e){
                    users.push($(this).attr('data-value'));
                })
                filter.push('authors='+users.join(','));
                emptyFilter = false;
                filterAjax.authors = users.join(',');
            }

            if(params.get('sort')){
                filter.push('sort='+params.get('sort'));
                emptyFilter = false;
                filterAjax.sort = params.get('sort');
            }


            if($('.filterUser .search__select--list div.active').length > 0){
                let users = [];
                $('.filterUser .search__select--list div.active').each(function (i,e){
                    users.push($(this).attr('data-value'));
                })
                filter.push('authors='+users.join(','));
                emptyFilter = false;
                filterAjax.authors = users.join(',');
            }

            if(dafCat && $('.filterMasechet .search__filter--list .search__select--list div.active').length > 0){
                $('.search__result--one').removeClass('hide');
            }else{
                $('.search__result--one').addClass('hide');
                $('.search__result--one .search__select--list div').removeClass('active');
                $('.search__result--one .search__select > span i').html('Select one...');
            }

            if(dafCat && $('.search__result--one .search__select--list div.active').length > 0 && !$('.search__result--one').hasClass('hide')){
                let currentPageOne = $('.search__result--one .search__select--list div.active').attr('data-tax');
                filter.push('page_numb='+currentPageOne);
                emptyFilter = false;
                filterAjax.page_numb = currentPageOne;
            }else{
                filterAjax.page_numb = '';
            }

            if(pageGlobal != 1){
                filter.push('page='+pageGlobal);
                emptyFilter = false;
                filterAjax.page = pageGlobal;
            }else{
                filterAjax.page = 1;
            }

            if(filter.length > 0){
                window.history.pushState('', '', currentLang+'/search/?' + filter.join('&'));
            }else{
                window.history.pushState('', '', currentLang+'/search/');
            }

            if(filter.length == 0 || emptyFilter) {
                $('.search__start').css('display', 'block');
                $('.search__result--text').css('display', 'none');
                $('.search__result--dafyomi').css('display', 'none');
                $('.search__pagination--left i, .search__head--bottom>span>i').html('-');
                $('.search__pagination--left span, .search__head--bottom>span>span').html('-');
            }else{
                $('.search__start').css('display', 'none');
                $('.search__result--text').css('display', 'flex');
            }


            if(bool && firstClick || !firstClick){
                firstClick = false;
                if($('.search__start').css('display') == 'none') {
                    getAjax();
                }
            }
        }


        $('.search__pagination--right').on('click', '.page-numbers:not(.prev):not(.next)', function (e){
            e.preventDefault();
            filterAjax.page = $(this).text();
            pageGlobal = $(this).text();
            generateLink();
        })

        $('.search__pagination--right').on('click', '.next', function (e){
            e.preventDefault();
            filterAjax.page = parseInt(pageGlobal)+1;
            pageGlobal = parseInt(pageGlobal)+1;
            generateLink();
        })

        $('.search__pagination--right').on('click', '.prev', function (e){
            e.preventDefault();
            filterAjax.page = parseInt(pageGlobal)-1;
            pageGlobal = parseInt(pageGlobal)-1;
            generateLink();
        })

        function checkUrl(){
            const params = new URL(window.location.href).searchParams;
            let clicked = false;
            let dafCat = false;

            if(params.get('input')){
                searchInput = params.get('input');

                $('.search__input input').val(searchInput);
                $('.search__result--text i').html(searchInput);
                $('.search__result--text').css('display', 'flex');
                checkFilterLength++;
            }

            if(params.get('masachet')) {
                $('.filterMasechet .search__filter--list .search__select--list div[data-tax="'+params.get('masachet')+'"]').click();
                clicked = true;
                checkFilterLength++;
                $('.search__result--one ').removeClass('hide');
                if(globalMassechet != params.get('masachet')) {
                    globalMassechet = params.get('masachet');
                    getPageNumber(params.get('masachet'));
                }

            }

            if(params.get('cat')) {
                $('.filterCat .search__filter--list div[data-cat="'+params.get('cat')+'"]').click();
                clicked = true;
                checkFilterLength++;
                if(params.get('cat') == 'daf' || params.get('all')){
                    dafCat = true;
                    $('.search__result--one').removeClass('hide');
                }else{
                    $('.search__result--one').addClass('hide');
                }
            }

            if(params.get('page_numb') && dafCat) {
                pageNumb = params.get('page_numb');
                $('.search__result--one .search__select--list div[data-tax="'+params.get('page_numb')+'"]').click();
                clicked = true;
                checkFilterLength++;
            }

            if(params.get('authors')) {
                let allUser = params.get('authors').split(',');
                $.each(allUser, function (i, e) {
                    $('.filterUser .search__select--list div[data-value="'+e+'"]').click();
                    checkFilterLength++;
                })
                clicked = true;
            }

            if(params.get('sort')) {
                checkFilterLength++;
            }

            if(clicked){
                $('.search__start').css('display', 'none');
            }

            generateLink(true);
        }

        if($('.search__start').length > 0) {
            filterAjax.search_page = 'yes';
            checkUrl();
        }

        function getAjax(){
            var ajaxurl = myAjax.ajaxurl;
            $.ajax({
                type: "POST",
                url: ajaxurl,
                data: {
                    "action": "get_element_search",
                    filterAjax
                },
                success: function (result) {
                   let results = result;
                   if(results && results.items){
                       $('.search__result--all').html('');
                       $('.search__pagination--right').html(results.pagination);
                       $('.search__pagination--left, .search__head--bottom').removeClass('hide');
                       $('.search__pagination--left i, .search__head--bottom>span>i').html(results.total);
                       $('.search__pagination--left span, .search__head--bottom>span>span').html(results.current);
                       $.each(results.items, function (i,e){
                           $(this).appendTo('.search__result--all');
                       })

                       addAnimation();
                   }
                }
            });
        }

        $('.search__result--all').on('click', '.search__item--checkmark', function (e){
            let btn = $(this);
            let remove = $(this).hasClass('active') ? 'yes' : 'no';
            let id_page = $(this).attr("data-id");
            e.preventDefault();
            var ajaxurl = myAjax.ajaxurl;
            $.ajax({
                type: "POST",
                url: ajaxurl,
                data: {
                    "action": "mark_as_complete_ajax",
                    'id_page': id_page,
                    'remove' : remove
                },
                success: function (result) {
                    if(result == 'added') {
                        btn.addClass('active');
                    }else{
                        btn.removeClass('active');
                    }
                }
            });
        })

        $('.search__result--all').on('click', '.search__item--bookmark:not(.beyond__follow)', function (e){
            let btn = $(this);
            let remove = $(this).hasClass('active') ? 'yes' : 'no';
            if($(this).hasClass('active_follow')){
                remove = 'yes';
            }
            let id_page = $(this).attr("data-id");
            e.preventDefault();
            var ajaxurl = myAjax.ajaxurl;
            $.ajax({
                type: "POST",
                url: ajaxurl,
                data: {
                    "action": "follow_ajax",
                    'id_page': id_page,
                    'remove' : remove
                },
                success: function (result) {
                    if(result == 'added') {
                        if(btn.hasClass('sfwd__courses')){
                            btn.addClass('active').addClass('active_follow');
                        } else {
                            $('.search__result--all .search__item--bookmark').addClass('active').addClass('active_follow');
                        }
                    }else{
                        if(btn.hasClass('sfwd__courses')){
                            btn.removeClass('active').removeClass('active_follow');
                        }else{
                            $('.search__result--all .search__item--bookmark').removeClass('active').removeClass('active_follow');
                        }
                    }
                }
            });
        })


        function getPageNumber(daf){
            var ajaxurl = myAjax.ajaxurl;
            $.ajax({
                type: "POST",
                url: ajaxurl,
                data: {
                    "action": "get_daf",
                    'daf': daf,
                },
                success: function (result) {
                    if(result.data) {
                        $('.search__result--one .search__select--list').html(' ');
                        if(result.data.length == 0){
                            $('.search__result--one .search__select > span i').html('Select one…');
                        }
                        for (let i = 0; i < result.data.length; ++i) {
                            $('<div data-tax="'+result.data[i]['slug']+'">'+result.data[i]['name']+'</div>').appendTo('.search__result--one .search__select--list');
                        }

                        if(pageNumb){
                            $('.search__result--one .search__select--list div[data-tax="'+pageNumb+'"]').click();
                            pageNumb = '';
                        }
                    }
                }
            });
        }

        $('.search-top__main').on('change', function (e){
            e.preventDefault();
            let val = $(".search-top__main option").filter(":selected").val();
            var ajaxurl = myAjax.ajaxurl;
            $.ajax({
                type: "POST",
                url: ajaxurl,
                data: {
                    "action": "get_select_top",
                    'daf': val,
                },
                success: function (result) {
                    $('.search-top__number select option').remove();
                    $('.search-top__number select').html(result)
                }
            });
        })

        $('.search-top__number').on('change', function (e){
            e.preventDefault();
            let val = $(".search-top__number option").filter(":selected").val();
            let mass = $(".search-top__main option").filter(":selected").val();
            var ajaxurl = myAjax.ajaxurl;
            $.ajax({
                type: "POST",
                url: ajaxurl,
                data: {
                    "action": "get_select_link",
                    'massechet': mass,
                    'page_numb': val,
                    'lang' : $('html').attr('lang') == 'en-US' ? 'en' : 'he'
                },
                success: function (result) {
                  window.location = result ?? currentLang+'/search?cat=daf&masachet='+mass+'&page_numb='+val;
                }
            });
            // window.location = '/search?cat=daf&masachet='+mass+'&page_numb='+val;
        })

        function addAnimation(){
            const animatedImages = document.querySelectorAll(
                '.search__item--buttons .animation-container'
            );

            [...animatedImages].forEach((el) => {
                const staticImage = el.querySelector('.animation-image');
                const dynamicLinkImage = el.querySelector('.jet-listing-dynamic-link__icon');

                if(el.querySelectorAll('.animation-container svg').length >	 1 || el.querySelectorAll('.animation-container.follow-ajax svg').length >= 1
                    || el.querySelectorAll('.animation-container.register-popup svg').length >= 1){
                    return;
                }

                let animationClassName = null;
                if (staticImage) {
                    animationClassName = [...staticImage.classList].find((className) => {
                        if (className.startsWith('animation-image-')) {
                            return true;
                        }
                    });
                } else if (dynamicLinkImage) {
                    animationClassName = [...el.classList].find((className) => {
                        if (className.startsWith('animation-image-')) {
                            return true;
                        }
                    });
                }

                if(!animationClassName){
                    return
                }

                const animationName = animationClassName.replace('animation-image-', '');

                const animationItem = bodymovin.loadAnimation({
                    container: el,
                    animType: 'svg',
                    loop: false,
                    autoplay: false,
                    path: AssetsPath.url + `/animations/${animationName}.json`,
                });

                if (staticImage) {
                    staticImage.classList.add('hidden');
                } else if (dynamicLinkImage) {
                    dynamicLinkImage.classList.add('hidden');
                }

                el.addEventListener('mouseenter', function () {
                    animationItem.goToAndStop(0, true);
                    animationItem.play();
                });

                el.addEventListener('complete', function () {
                    animationItem.goToAndStop(0, true);
                });
            });
        }

    }
}